import React from "react";
import "./service_offers.scss";

const ServiceOffers = () => {
  const offers = [
    {
      title: "Bookkeeeping Services",
      desc: "Whether you’re just starting out or running a growing small business, accurate bookkeeping is key to understanding your finances. Let our skilled team handle the numbers with our startup bookkeeping solutions that include financial statement preparation and monthly reconciliation service, while you focus on building your business.",
      link: "https://www.finlotax.com/services/bookkeeping-services",
    },
    {
      title: "Tax-Startups & Businesses",
      desc: "The team of professionals at FinloTax can handle all your business needs such as Federal &amp; State tax filing, franchise tax filing efficiently, saving your time and effort.",
      link: "https://www.finlotax.com/services/business-tax-services",
    },
    {
      title: "Tax-Individuals",
      desc: "FinloTax offers expert planning, preparation, and filing services you can count on-delivered by experienced enrolled agents and tax specialists ensures every detail is handled with care and accuracy. We guide you through the process of applying for Individual Taxpayer Identification Number (ITIN), wherever you live in California and all states in the US.",
      link: "https://www.finlotax.com/services/individual-tax-services",
    },
    {
      title: "Company Incorporation",
      desc: "The experts at FinloTax help you seamlessly incorporate your business—whether it’s an LLC, C Corporation, S-Corporation, or non-profit. We handle everything from Articles of Incorporation and EIN registration to required annual filings.",
      link: "https://www.finlotax.com/services/company-incorporation",
    },
    {
      title: "CFO Services",
      desc: "The CFO examines financial statements, KPIs, and other relevant data to analyze business performance and extract key insights. Monitor KPIs: Track KPIs such as profit margins, return on investment (ROI), earnings before interest, taxes, depreciation, and amortization (EBITDA), and more.",
      link: "https://www.finlotax.com/services/cfo-services",
    },
    {
      title: "R&D Credit",
      desc: "R&D tax credits are government incentives aimed at rewarding businesses that invest in innovation, technology, and development. These credits can offset federal and state tax liabilities, providing essential cash flow to reinvest in future projects.",
      link: "https://www.finlotax.com/services/r&d-credit",
    },
    {
      title: "Payroll Services",
      desc: "FinloTax provides reliable and efficient payroll management services for small and mid-sized businesses. We handle regular payroll processing, compliance payroll services, tax withholdings and ensures the business is compliant.",
      link: "https://www.finlotax.com/services/payroll-services",
    },
    {
      title: "Tax Planning and Advisory",
      desc: "FinloTax offers tailored tax planning for individuals and business owners to maximize deductions and minimize tax liabilities. Includes planning for capital gains, real estate, stocks, and retirement, as well as advice on business strategies like entity setup and structuring for tax purposes, and expense optimization aligned with long-term financial goals.",
      link: "https://www.finlotax.com/services/tax-planning-and-advisor-services",
    },
    {
      title: "Compliance Services",
      desc: "FinloTax provides comprehensive compliance services for both individuals and businesses, with a strong focus on ensuring accurate and timely filings across domestic and international requirements. This includes federal, state, and local tax filings, and specialized support for foreign compliance such as FBAR, FATCA, and foreign income and entity disclosures.",
      link: "https://www.finlotax.com/services/compliance-services",
    },
  ];

  return (
    <div className="services-container">
      {/* <h2 className="services-header">Our Service</h2> */}
      <div className="services-grid">
        {offers.map((item, index) => (
          <div className="service-card" key={index}>
            <div className="service-card-top">
              <h3 className="service-title">{item.title}</h3>
              <p className="service-desc">{item.desc}</p>
            </div>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="know-more-link"
            >
              Know more <span className="arrow">›</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceOffers;
